/**
 * @author jakubbujakowski
 * @since 2020-5-29
 */

import * as React from "react";

import { ADMIN_DASHBOARD_LINK } from "@config/links";

import { Container } from "@ui/Atoms/Grid";
import { SmallHeading } from "@ui/Atoms/Headings";
import { Section, Paragraph, OptionPanel } from "@ui/Atoms";

export const ImpersonatorNotification = () => (
  <Container>
    <Section small>
      <OptionPanel>
        <SmallHeading>This section is available only to users</SmallHeading>
        <Paragraph>Please impersonate someone first.</Paragraph>
        <a href={ADMIN_DASHBOARD_LINK}>Admin dashboard</a>
      </OptionPanel>
    </Section>
  </Container>
);
